import { EP } from './../configs/constant';
import { getPath } from "../helpers/handleUrl";
import { IShipPayload } from '../types/ship';
import axiosThirdService, { AxiosThirdService } from "./axiosThirdService";
class ShipService {
    readonly service: AxiosThirdService;
    constructor() {
        this.service = axiosThirdService;
    }
    async calculateShippingPrice(payload: IShipPayload) {
        return this.service.post<any>(getPath(EP.API, EP.V1, EP.SHIP, EP.CALCULATE), payload);
    }
}
const shipService = new ShipService();
export default shipService;